import React from 'react';
import { useTranslation } from 'react-i18next';
import emptyMediaIcon from '@assets/icons/empty-media.svg';
import { Button } from '@mui/material';
import { ICONS } from '@components/icons/icon.tsx';

const EmptyContent: React.FC<{
  onFolderOpen: () => void;
  onMediaOpen: () => void;
}> = ({ onMediaOpen, onFolderOpen }) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col justify-center items-center gap-12 max-lg-xl:gap-7">
      <div className="flex flex-col items-center gap-4">
        <div>
          <img
            className="!w-[210px] !h-[206px] max-lg-xl:!w-[160px] max-lg-xl:!h-[140px]"
            src={emptyMediaIcon}
            alt="Empty media icon"
          />
        </div>

        <div>
          <p className="text-[var(--blue-4)] text-[30px] font-semibold opacity-40 max-lg-xl:text-[20px]">
            {t('media_library_empty_folder_title')}
          </p>

          <p className="text-[var(--blue-4)] text-[16px] font-semibold opacity-50 max-lg-xl:text-[14px]">
            {t('media_library_empty_folder_desc')}
          </p>
        </div>
      </div>

      <div className="flex items-center gap-3.5">
        <Button
          className="!min-w-[170px]"
          variant="outlined"
          startIcon={ICONS.plusBlackIcon}
          onClick={onFolderOpen}
        >
          {t('add_folder')}
        </Button>

        <Button
          className="!min-w-[170px]"
          variant="contained"
          color="primary"
          startIcon={ICONS.plusIcon}
          onClick={onMediaOpen}
        >
          {t('add_media')}
        </Button>
      </div>
    </div>
  );
};

export default EmptyContent;
